export default {"src":"/_next/static/media/primary.67667351.svg","height":109,"width":102,"blurWidth":0,"blurHeight":0};